// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import { AutoSizer, Table, Column } from 'react-virtualized'
// Componentes
import {
    ModalTrigger,
    ModalEditarProduccion,
} from './Modales.jsx'
// Styles
import * as css from '../../admin/MantenedorPersonal/tablaPersonal.css'

export class TablaProducciones extends React.Component {
    render(){
        return (
            <div style={{height: '80%'}}>
                <AutoSizer>
                    {({height, width}) =>
                        <Table
                            // general
                            height={height}
                            width={width}
                            // headers
                            headerHeight={30}
                            headerClassName={css.headerColumn}
                            // rows
                            rowCount={this.props.producciones.length}
                            rowGetter={({index})=> this.props.producciones[index]}
                            rowHeight={40}
                            rowClassName={({index})=> index<0? css.headerRow : ((index%2===0)? css.evenRow : css.oddRow)}
                        >
                            {/* INDEX */}
                            <Column
                                dataKey='#'
                                label={'#'}
                                disableSort={true}
                                cellRenderer={({rowIndex}) => rowIndex+1}
                                width={30}
                            />
                            {/* NOMBRE PROVINCIA*/}
                            <Column
                                dataKey={'nombre'} label="Nombre"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                                width={190}
                            />
                            <Column
                                dataKey={'descripcion'} label="Descripción"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                                width={600}
                            />
                            <Column
                                dataKey={'produccionFormateada'} label="Producción"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                                width={130}
                            />
                            <Column
                                dataKey={'produccionReal'} label="Real"
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                                width={130}
                            />
                            <Column
                                dataKey='opciones'
                                label={'Editar'}
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => (
                                    <div>
                                        {/* Editar */}
                                        <BotonEditar
                                            idProduccion={rowData.idProduccion}
                                            actualizarValor={this.props.editarValor}
                                            produccion={rowData.produccion}
                                        />
                                    </div>
                                )}
                                width={90}
                            />
                        </Table>
                    }
                </AutoSizer>
            </div>
        )
    }
}
const BotonEditar = ({idProduccion, actualizarValor, produccion})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-xs btn-primary" onClick={showModal}>
                Edición
                {isVisible && <ModalEditarProduccion
                    idProduccion={idProduccion}
                    actualizarValor={actualizarValor}
                    hideModal={hideModal}
                    produccion={produccion}
                />}
            </button>
        }
    </ModalTrigger>
TablaProducciones.propTypes = {
    producciones: PropTypes.arrayOf(PropTypes.object).isRequired
}


// WEBPACK FOOTER //
// ./frontEnd/admin/mantenedorProducciones/TablaProducciones.jsx